var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'lotto': true }},[_vm._t("default"),_vm._v(" "),_c('svg',{class:{ 'arrow': true },attrs:{"viewBox":"0 0 19 12"}},[_c('use',{attrs:{"xlink:href":"#icon-arrow-right"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }